import React, { useState, useEffect, useRef } from 'react';
import { NavbarBrand } from 'react-bootstrap';
import constants from '../../constants';
import SideNav from '../SideNav/SideNav';
import Logout from '../../containers/Logout/Logout';
import { connect } from 'react-redux';
import actions from '../../actions';
import DataManagement from '../../containers/DataManagement/DataManagement';
import UserManagement from '../../containers/UserManagement/UserManagement';
import AccountManagement from '../../containers/AccountManagement/AccountManagement';
import CancelRapidManual from '../../components/CancelRapidManual/CancelRapidManual';
import history from '../CreateBrowserHistory/CreateBrowserHistory';
import MessagePopup from '../../components/MessagePopup/MessagePopup';
import RoleBasedNavLink from '../../components/RoleBasedNavLink/RoleBasedNavLink';
import modalConstants from '../Header/modalConstants';
import verantosIcon from '../../images/Verantos_icon.svg';

const Menu = (props) => {
	const [visible, setVisible] = useState(true);
	return (
		<div className="menu">
			<div className={(visible ? 'visible ' : '') + props.alignment}>{props.children}</div>
		</div>
	);
};

const MenuItem = ({ children }) => <div className="menu-item">{children}</div>;

const Sidebar = (props) => {
	const [datapageUrl, setDatapageUrl] = useState('');
	const [navPath, setNavPath] = useState('');
	let { userRole } = props.sidenav;

	const logoutModal = useRef(null);
	const userManagementModal = useRef(null);
	const accountManagementModal = useRef(null);
	const dataManagementModal = useRef(null);
	const confirmPopup = useRef(null);
	const messagePopup = useRef(null);

	useEffect(() => {
		try {
			if (!props.sidenav.userRole.Role) {
				props.dispatch(actions.GetUserRole());
			}
		} catch (error) {
			console.log(error);
		}
	}, []);

	useEffect(() => {
		// It takes prop modal from store and opens desired modal window.
		switch (props?.modal?.type) {
			case modalConstants.logout:
				logoutModal.current.handleClick();
				break;
			case modalConstants.productSetting:
				userManagementModal.current.handleClick();
				break;
			case modalConstants.accountSetting:
				accountManagementModal.current.handleClick();
				break;
			case modalConstants.dataSetting:
				dataManagementModal.current.handleClick();
				break;
			default:
				break;
		}
	}, [props?.modal]);

	const cancelUpdate = () => {
		window.localStorage.removeItem('newRapidAnnotation');
		window.localStorage.removeItem('selectedConcept');
		window.localStorage.removeItem('editmodeNormal');
		window.localStorage.removeItem('updatedAnnotation');
		window.localStorage.removeItem('deletedAnnotation');
		window.localStorage.removeItem('fromEditMultipleManual');
		props.dispatch(actions.setFilterText(''));
		props.dispatch(actions.setSideNavList([]));
		props.dispatch(actions.removeHistory([]));
		history.push(navPath);
	};

	/*****************************************
	 * Function name: changeNavHistory
	 * Description: Sets filtered text and side navigation options.
	 ****************************************/
	const changeNavHistory = (event, url) => {
		sessionStorage.setItem('storedHistory', JSON.stringify([]));
		let temp = window.localStorage.getItem('newRapidAnnotation');
		let newRapidAnnotationTemp = temp ? JSON.parse(temp) : '';
		let tempUpdated = window.localStorage.getItem('updatedAnnotation');
		let updatedAnnotation = tempUpdated ? JSON.parse(tempUpdated) : '';
		let tempDeleted = window.localStorage.getItem('deletedAnnotation');
		let deletedAnnotation = tempDeleted ? JSON.parse(tempDeleted) : '';
		setNavPath(url);

		if (newRapidAnnotationTemp || updatedAnnotation || deletedAnnotation) {
			setDatapageUrl(window.location.pathname);
			confirmPopup.current.handleClick();
			return;
		} else if (sessionStorage.getItem('PreviewText')) {
			setDatapageUrl(url);
			messagePopup.current.handleClick();
			event.isPropagationStopped();
			return;
		} else {
			window.localStorage.removeItem('newRapidAnnotation');
			window.localStorage.removeItem('selectedConcept');
			window.localStorage.removeItem('editmodeNormal');
			window.localStorage.removeItem('viewmodeDocument');
			window.localStorage.removeItem('fromDataManual');
			props.dispatch(actions.setFilterText(''));
			props.dispatch(actions.setSideNavList([]));
			props.dispatch(actions.removeHistory([]));
		}
		history.push(url);
	};

	const rootClosexit = (event) => {
		history.push(datapageUrl);
	};

	const redirectToPage = () => {
		sessionStorage.setItem('PreviewText', '');
		sessionStorage.removeItem('patientpreviewdata');
		history.push(datapageUrl);
	};

	const resetState = (oldUrl) => {
		if (props.resetState) {
			props.resetState(oldUrl);
		}
	};

	return (
		<div>
			<Menu alignment="left">
				<NavbarBrand>
					<div className="top_nav">
						<ul>
							<li key={'homelink'} style={{ height: 50 }} className="event">
								<div className="ver-logo-wrapper">
									<img className="logo-icon ver-logo" src={verantosIcon} />
								</div>
							</li>

							{userRole && userRole.Role && (
								<RoleBasedNavLink
									userRole={userRole.Role}
									onClick={(event, path) => changeNavHistory(event, path)}
								/>
							)}
						</ul>
					</div>
				</NavbarBrand>
				<div id="navigation-menu">
					<SideNav resetState={resetState} />
				</div>
			</Menu>
			<Logout open={(c) => (logoutModal.current = c)} />
			<DataManagement open={(c) => (dataManagementModal.current = c)} />
			<AccountManagement open={(c) => (accountManagementModal.current = c)} />
			<UserManagement open={(c) => (userManagementModal.current = c)} />
			<CancelRapidManual
				open={(c) => (confirmPopup.current = c)}
				rootClosexit={(event) => rootClosexit(event)}
				cancelRapidUpdate={cancelUpdate}
				revertRapidChanges={cancelUpdate}
			/>
			<MessagePopup
				open={(c) => (messagePopup.current = c)}
				rootClosexit={() => {}}
				text={
					'If you exit preview, your changes will be lost. Are you sure you want to exit preview?'
				}
				confirmClick={redirectToPage}
			/>
		</div>
	);
};

const mapStateToProps = (state) => state;
export default connect(mapStateToProps)(Sidebar);
